export default __webpack_public_path__ + "7ad52d55510af76617200a4bc8212ae2.png";